// extracted by mini-css-extract-plugin
module.exports = {"container":"userSearchBar_container__WrK43","submit":"userSearchBar_submit__2Z4Dc"};